import _ from 'lodash';

import { getPostMap } from './post-selectors';

// prettier-ignore
export const getRecentPosts = (state, postId) => _(getPostMap(state))
  .pick(_.get(state.recentPostsIds, postId))
  .values()
  .value();
